import { render, staticRenderFns } from "./ProductPage.component.pug?vue&type=template&id=2ab75cd4&scoped=true&lang=pug&"
import script from "./ProductPage.component.ts?vue&type=script&lang=ts&"
export * from "./ProductPage.component.ts?vue&type=script&lang=ts&"
import style0 from "./ProductPage.component.scss?vue&type=style&index=0&id=2ab75cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab75cd4",
  null
  
)

export default component.exports